import { createAction } from '@reduxjs/toolkit';
import StatisticsParamVO from 'commons/vo/param/StatisticsParamVO';
import {
  REQUEST_STATISTICS_ASSET,
  REQUEST_STATISTICS_ASSET_SUCCESS,
  REQUEST_STATISTICS_ASSET_FAILURE,
  REQUEST_STATISTICS_PARTIAL,
  REQUEST_STATISTICS_PARTIAL_SUCCESS,
  REQUEST_STATISTICS_PARTIAL_FAILURE,
  REQUEST_STATISTICS_DOWNLOAD,
  REQUEST_STATISTICS_DOWNLOAD_SUCCESS,
  REQUEST_STATISTICS_DOWNLOAD_FAILURE,
  REQUEST_STATISTICS_STREAMING,
  REQUEST_STATISTICS_STREAMING_SUCCESS,
  REQUEST_STATISTICS_STREAMING_FAILURE,
  REQUEST_STATISTICS_LOGIN,
  REQUEST_STATISTICS_LOGIN_SUCCESS,
  REQUEST_STATISTICS_LOGIN_FAILURE,
  REQUEST_STATISTICS_STORAGE,
  REQUEST_STATISTICS_STORAGE_SUCCESS,
  REQUEST_STATISTICS_STORAGE_FAILURE,
  REQUEST_STATISTICS_EXPORT,
  REQUEST_STATISTICS_EXPORT_SUCCESS,
  REQUEST_STATISTICS_EXPORT_FAILURE,
} from './types';
import StatisticsExportParamVO from 'commons/vo/param/StatisticsExportParamVO';

// 에셋
export const requestStatisticsAsset = createAction<
  { param: StatisticsParamVO },
  typeof REQUEST_STATISTICS_ASSET
>(REQUEST_STATISTICS_ASSET);
export const requestStatisticsAssetSuccess = createAction<
  {
    statisticsAsset: any;
  },
  typeof REQUEST_STATISTICS_ASSET_SUCCESS
>(REQUEST_STATISTICS_ASSET_SUCCESS);
export const requestStatisticsAssetFailure = createAction(REQUEST_STATISTICS_ASSET_FAILURE);

// 부분인출
export const requestStatisticsPartial = createAction<
  { param: StatisticsParamVO },
  typeof REQUEST_STATISTICS_PARTIAL
>(REQUEST_STATISTICS_PARTIAL);
export const requestStatisticsPartialSuccess = createAction<
  {
    statisticsPartial: any;
  },
  typeof REQUEST_STATISTICS_PARTIAL_SUCCESS
>(REQUEST_STATISTICS_PARTIAL_SUCCESS);
export const requestStatisticsPartialFailure = createAction(REQUEST_STATISTICS_PARTIAL_FAILURE);

// 다운로드
export const requestStatisticsDownload = createAction<
  { param: StatisticsParamVO },
  typeof REQUEST_STATISTICS_DOWNLOAD
>(REQUEST_STATISTICS_DOWNLOAD);
export const requestStatisticsDownloadSuccess = createAction<
  {
    statisticsDownload: any;
  },
  typeof REQUEST_STATISTICS_DOWNLOAD_SUCCESS
>(REQUEST_STATISTICS_DOWNLOAD_SUCCESS);
export const requestStatisticsDownloadFailure = createAction(REQUEST_STATISTICS_DOWNLOAD_FAILURE);

// 스트리밍
export const requestStatisticsStreaming = createAction<
  { param: StatisticsParamVO },
  typeof REQUEST_STATISTICS_STREAMING
>(REQUEST_STATISTICS_STREAMING);
export const requestStatisticsStreamingSuccess = createAction<
  {
    statisticsStreaming: any;
  },
  typeof REQUEST_STATISTICS_STREAMING_SUCCESS
>(REQUEST_STATISTICS_STREAMING_SUCCESS);
export const requestStatisticsStreamingFailure = createAction(REQUEST_STATISTICS_STREAMING_FAILURE);

// 로그인
export const requestStatisticsLogin = createAction<
  { param: StatisticsParamVO },
  typeof REQUEST_STATISTICS_LOGIN
>(REQUEST_STATISTICS_LOGIN);
export const requestStatisticsLoginSuccess = createAction<
  {
    statisticsLogin: any;
  },
  typeof REQUEST_STATISTICS_LOGIN_SUCCESS
>(REQUEST_STATISTICS_LOGIN_SUCCESS);
export const requestStatisticsLoginFailure = createAction(REQUEST_STATISTICS_LOGIN_FAILURE);

// 스토리지
export const requestStatisticsStorage = createAction<typeof REQUEST_STATISTICS_STORAGE>(
  REQUEST_STATISTICS_STORAGE,
);
export const requestStatisticsStorageSuccess = createAction<
  {
    statisticsStorage: any;
  },
  typeof REQUEST_STATISTICS_STORAGE_SUCCESS
>(REQUEST_STATISTICS_STORAGE_SUCCESS);
export const requestStatisticsStorageFailure = createAction(REQUEST_STATISTICS_STORAGE_FAILURE);

// 에셋 export
export const requestStatisticsExport = createAction<
  { param: StatisticsExportParamVO },
  typeof REQUEST_STATISTICS_EXPORT
>(REQUEST_STATISTICS_EXPORT);
export const requestStatisticsExportSuccess = createAction(REQUEST_STATISTICS_EXPORT_SUCCESS);
export const requestStatisticsExportFailure = createAction(REQUEST_STATISTICS_EXPORT_FAILURE);
